import React, { Component } from "react";
import SentenceTrendsIndicator from "./SentenceTrendsIndicator";
import SentenceTrendsEditButton from "./SentenceTrendsEditButton";
import { pickT2wField, rowToOverrideSentences } from "./tpTrends2WatchUtils";

const SENTENCE_TRENDS_METRICS_STRIP_URL =
  "https://d2onbxnrte2nim.cloudfront.net/non-covers/042326_dashboard_graphic_1.png";

class SentenceTrendsBody extends Component {
  /** Fallback neighborhood line when API does not send `t2WAreaName`. */
  formatAreaName = () => {
    const { mlsNeighborhood, mlsAreaID } = this.props.currentArea || {};
    const { subdivisionName } = this.props.hoData || {};

    if (subdivisionName) {
      return subdivisionName;
    }
    if (mlsAreaID === "SCL-16J") {
      return "Your Neighborhood";
    }
    if (mlsAreaID === "SMA-392") {
      return "Isle Cove - Neighborhood 9, Foster City";
    }
    if (mlsAreaID === "SMA-398") {
      return "Treasure Isle - Neighborhood 1, Foster City";
    }
    if (mlsAreaID === "SMA-390") {
      return "Sea Colony - Neighborhood 7, Foster City";
    }
    if (mlsNeighborhood && mlsNeighborhood.length > 28) {
      return "Your Neighborhood";
    }
    return mlsNeighborhood;
  };

  areaTitleLine = () => {
    const { t2wDraft } = this.props;
    if (t2wDraft) {
      const fromApi = pickT2wField(
        t2wDraft,
        "t2WAreaName",
        "orgT2WAreaName",
        "",
      );
      if (String(fromApi || "").trim()) return fromApi;
    }
    return this.formatAreaName();
  };

  render() {
    const {
      agentData,
      currentArea,
      t2wDraft,
      showEditButtons,
      onEditTrend,
      onEditTakeaway,
      editedTrendFlags,
      isTakeawayEdited,
      editDisabled,
    } = this.props;
    const { mlsAreaID } = currentArea || {};
    const { listgenUserID } = agentData || {};

    let titleStyles = "";
    let areaLength = this.areaTitleLine() ? this.areaTitleLine().length : 0;
    if (areaLength && areaLength > 54) {
      titleStyles = "sentence-title-26";
    } else if (areaLength && areaLength > 46) {
      titleStyles = "sentence-title-28";
    }
    const showBottomLine = true;

    let bottomLineStyles;

    let dbIndicatorContainerStyles;

    const useT2w = Boolean(t2wDraft);

    const sentencesForDisplay = useT2w
      ? rowToOverrideSentences(t2wDraft) || []
      : [];

    const bottomLineTitle = useT2w
      ? pickT2wField(
          t2wDraft,
          "t2WSummaryHeading",
          "orgT2WSummaryHeading",
          "Take Away:",
        )
      : "Take Away:";
    const bottomLineBody = useT2w
      ? pickT2wField(t2wDraft, "t2WSummaryText", "orgT2WSummaryText", "")
      : "";

    let isPachecoValle = mlsAreaID === "MRN-A1700K";
    let pachecoValleHeader = (
      <div className="sentence-trends-db-body-header sentence-trends-pacheco-valle-header">
        <p className={`sentence-trends-db-body-header-title ${titleStyles}`}>
          {this.areaTitleLine()}
        </p>
        <p className="sentence-trends-db-body-header-subtitle">
          The market stats shown below reflect condos, townhomes, and
          single-family homes.
        </p>
      </div>
    );
    return (
      <div className="sentence-trends-db-body">
        {isPachecoValle ? (
          pachecoValleHeader
        ) : (
          <div className="sentence-trends-db-body-header">
            <p
              className={`sentence-trends-db-body-header-title ${titleStyles}`}
            >
              {this.areaTitleLine()}
            </p>
          </div>
        )}
        <div className="sentence-trends-metrics-strip-wrap">
          <img
            src={SENTENCE_TRENDS_METRICS_STRIP_URL}
            alt=""
            className="sentence-trends-metrics-strip-img"
          />
        </div>

        <div
          className={`sentence-trends-indicator-container ${dbIndicatorContainerStyles}`}
        >
          {sentencesForDisplay.length === 0 ? (
            <div className="sentence-trends-no-api-data"></div>
          ) : (
            sentencesForDisplay.map((sentence, index) => (
              <SentenceTrendsIndicator
                key={`${sentence.header}-${index}`}
                header={sentence.header}
                logic={sentence.logic}
                statement={sentence.statement}
                benefit={sentence.benefit}
                index={index + 1}
                listgenUserID={listgenUserID}
                mlsAreaID={mlsAreaID}
                showEditButton={showEditButtons}
                onEditClick={() => onEditTrend?.(index + 1)}
                isEdited={Boolean(editedTrendFlags?.[index + 1])}
                editDisabled={editDisabled}
              />
            ))
          )}
        </div>
        {showBottomLine && (
          <div className={`sentence-trends-bottom-line ${bottomLineStyles}`}>
            {showEditButtons ? (
              <SentenceTrendsEditButton
                label="Edit Take Away"
                isEdited={isTakeawayEdited}
                onClick={onEditTakeaway}
                disabled={editDisabled}
                className="sentence-trends-edit-btn-takeaway"
              />
            ) : null}
            <div className="sentence-trends-bottom-line-title">
              {bottomLineTitle}
            </div>{" "}
            <div className="sentence-trends-bottom-line-text">
              {bottomLineBody}{" "}
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default SentenceTrendsBody;
